import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { DryUser, SyncAccessRequest, SyncAccessResponse } from '../models/payload';

@Injectable({
  providedIn: 'root',
})
export class UserDetailsService {
  private http = inject(HttpClient);

  findUserRolePermissions(username: string): Observable<DryUser> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
    return this.http.post<DryUser>(
      environment.baseUrl + 'User/customers-roles-permissions',
      {
        userName:username
      },
      httpOptions
    );
  }

  syncAccess(request: SyncAccessRequest): Observable<SyncAccessResponse> {
    return this.http.put<SyncAccessResponse>(
      environment.baseUrl + 'auth/sync-access',
      request,
      { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) }
    );
  }
}
